module.exports = __webpack_public_path__ + "img/instagram.9a2035d7.svg";